export const ACTION_SET_BALANCE = "ACTION_SET_BALANCE"
export const ACTION_SET_COMISSION = "ACTION_SET_COMISSION"
export const ACTION_SET_FUNDS = "ACTION_SET_FUNDS"
export const ACTION_SET_BALANCE_WALLET = "ACTION_SET_BALANCE_WALLET"
export const ACTION_SET_PROFIT_NOW = "ACTION_SET_PROFIT_NOW"
export const ACTION_SET_BALANCE_INVESTMENT = "ACTION_SET_BALANCE_INVESTMENT"
export const ACTION_SET_COMISSION_SUMM_NOT_PAYMENT = "ACTION_SET_COMISSION_SUMM_NOT_PAYMENT"
export const ACTION_SET_STAT_USER = "ACTION_SET_STAT_USER"